import { useState } from 'react';

import { Button } from '@iwoca/orion';

import { useGetANTFormalOffers } from '../../../hooks/useGetANTFormalOffers';
import { useUpdateTurnover } from '../../../hooks/useUpdateTurnover';
import { formatCurrency } from '../../../utils/currency';

export const RefreshExpiredLimits = ({
  loading,
  setIsSpendingLimitDrawerOpen,
  refreshSpendingLimit,
}: {
  loading: boolean;
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refreshSpendingLimit: () => void;
  className?: string;
}) => {
  const [showSupersedeModal, setShowSupersedeModal] = useState(false);
  const { antFormalOffers } = useGetANTFormalOffers();
  const coreANTOffers = antFormalOffers.filter(
    (offer) => offer?.product_type !== 'iwocapay',
  );

  const { isTurnoverExpired } = useUpdateTurnover();

  const handleClick = () => {
    if (coreANTOffers.length > 0) {
      return setShowSupersedeModal(true);
    }
    setIsSpendingLimitDrawerOpen(true);
    if (!isTurnoverExpired) {
      refreshSpendingLimit();
    }
  };

  return (
    <>
      {showSupersedeModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
          <div className="rounded-lg mx-m max-w-md bg-white p-l">
            <h1 className="mt-s text-xl font-bold">
              Once you hit continue we'll need to re-run your existing
              Flexi-Loan offer for{' '}
              {formatCurrency(coreANTOffers[0]?.available_credit || 0)}
            </h1>
            <p className="text-base mt-s font-reg">
              Don't worry &mdash; you won't need to give us any more documents
              to do this. To see your Flexi-Loan offer, go to your iwoca
              dashboard.
            </p>
            <div className="gap-2 mt-s flex">
              <Button onClick={() => refreshSpendingLimit()}>
                Continue with iwocaPay
              </Button>
              <Button
                onClick={() => setShowSupersedeModal(false)}
                variant="tertiary"
              >
                Go back
              </Button>
            </div>
          </div>
        </div>
      )}
      <button
        className={`grid grid-cols-[15px_1fr] gap-s bg-transparent p-0 text-[color:var(--color-primary-40,#4b4bff)]`}
        onClick={() => handleClick()}
        disabled={loading}
        title="Subject to approval and reassessed every 30 days — if something changes with your business the amounts might change."
      >
        {loading ? (
          <>
            <div>
              <svg
                className="h-4 w-4 animate-spin"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
              </svg>
            </div>
            <div>Checking limit...</div>
          </>
        ) : (
          <>
            <div>
              <svg
                className="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
              </svg>
            </div>
            <div>Secure my limit</div>
          </>
        )}
      </button>
    </>
  );
};
